import { defineStore } from 'pinia';

export const useNavCategoryStore = defineStore('navCategory', {
  state: () => ({
    categories: [] as any[], // Array to hold the list of categories
    categoryData: {} as { [key: string]: any }, // Object to store data for individual categories
    breadcrumbs: {} as { [key: string]: any }, // Object to store breadcrumb data for each category
    loading: false, // Loading state for indicating data fetching
  }),
  actions: {
    /**
     * Set categories list in the store
     * @param data - List of categories
     */
    setCategories(data: any[]) {
      this.categories = data;
    },

    /**
     * Set data for a specific category in the store
     * @param category - The name or identifier of the category
     * @param data - The data to store for the category
     */
    setCategoryData(category: string, data: any) {
      this.categoryData[category] = data;
    },

    /**
     * Set breadcrumb data for a specific category in the store
     * @param category - The name or identifier of the category
     * @param data - The breadcrumb data to store for the category
     */
    setBreadcrumbs(category: string, data: any) {
      this.breadcrumbs[category] = data;
    },

    /**
     * Set loading state for data fetching
     * @param isLoading - Boolean indicating loading state
     */
    setLoading(isLoading: boolean) {
      this.loading = isLoading;
    },

    /**
     * Clear all data from the store
     */
    clearStore() {
      this.categories = [];
      this.categoryData = {};
      this.breadcrumbs = {};
      this.loading = false;
    },

    // fetch categories from the API
  },
});
